import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch, connect } from 'react-redux';

import Intro from './Intro';
import Resources from './Resources';
import Summary from './Summary';
import Section from '../../components/Section';
import * as AppRoute from '../../utils/appRoutes';
import { prepareComponents } from '../../utils/helpers';
import { select } from '../../rematcher/store';

const components = [Intro, Resources, Summary];

function KeyResources({
  locales,
  locales: {
    keyResources: { name, menu, sectionName },
  },
  progress,
}) {
  const {
    keyActivity: { fetchKeyActivities },
    keyResource: { fetchKeyResources },
    bmc: { fetchCurrentBmc, updateBmc },
  } = useDispatch();

  const {
    bmc: { current: currentBmc },
  } = useSelector((state) => state);

  const { bmcId } = useParams();
  const preparedComponents = prepareComponents(
    components,
    bmcId,
    menu,
    AppRoute.keyResources,
  );

  function getData() {
    fetchCurrentBmc(bmcId);
    fetchKeyResources(bmcId);
    fetchKeyActivities(bmcId);
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (currentBmc.id)
      updateBmc({
        id: currentBmc.id,
        name: 'key_resources_progress',
        value: parseInt(progress),
      });
  }, [progress]);

  return (
    <Section
      components={preparedComponents}
      sectionName={sectionName}
      sectionLocaleName={name}
      menuItems={menu}
      progress={progress}
      locales={locales}
      finalDestination={AppRoute.bmc(bmcId)}
      // eslint-disable-next-line react/jsx-no-bind
      onComponentChange={getData}
    />
  );
}

const mapState = select((models) => ({
  progress: models.progress.keyResourceProgress,
}));

export default connect(mapState, null)(KeyResources);
